var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import { Api } from '@app/Api';
import { DocumentCategoryDialogGrid } from '../DocumentCategoryGrid/DocumentCategoryDialogGrid';
import { Button } from '@app/Components/Button/Button';
import styles from './DocumentCategoryDialogBody.module.scss';
import { CreateDocumentCategoryDialog } from '../CreateDocumentCategoryDialog/CreateDocumentCategoryDialog';
export var DocumentCategoryDialogBody = /** @class */ (function (_super) {
    __extends(DocumentCategoryDialogBody, _super);
    function DocumentCategoryDialogBody() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isCreateDocumentCategoryOpen = false;
        _this._loading = false;
        _this._documentCategories = undefined;
        _this._allowedOnlyActiveCategories = false;
        return _this;
    }
    DocumentCategoryDialogBody.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._loadDocumentCategories()];
                    case 1:
                        _a.sent();
                        this._allowedOnlyActiveCategories = !!this.props.project.allowedOnlyActiveCategories;
                        return [2 /*return*/];
                }
            });
        });
    };
    DocumentCategoryDialogBody.prototype._loadDocumentCategories = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, , 2, 3]);
                        this._loading = true;
                        _a = this;
                        return [4 /*yield*/, Api.secured.getDocumentCategoriesForProject({
                                projectId: this.props.project.id
                            })];
                    case 1:
                        _a._documentCategories = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this._loading = false;
                        return [7 /*endfinally*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DocumentCategoryDialogBody.prototype._reloadDocumentCategories = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._loadDocumentCategories()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DocumentCategoryDialogBody.prototype._toggleCreateDocumentCategoryModal = function () {
        this._isCreateDocumentCategoryOpen = !this._isCreateDocumentCategoryOpen;
    };
    DocumentCategoryDialogBody.prototype._deleteDocumentCategory = function (documentCategoryId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Api.secured.deleteDocumentCategory({ categoryId: documentCategoryId, projectId: this.props.project.id })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this._reloadDocumentCategories()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DocumentCategoryDialogBody.prototype._setIsActiveInProject = function (documentCategoryId, value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!value) return [3 /*break*/, 2];
                        return [4 /*yield*/, Api.secured.setDocumentCategoryToProject({
                                documentCategoryId: documentCategoryId,
                                projectId: this.props.project.id
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, Api.secured.deleteDocumentCategoryFromProject({
                            documentCategoryId: documentCategoryId,
                            projectId: this.props.project.id
                        })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [4 /*yield*/, this._reloadDocumentCategories()];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DocumentCategoryDialogBody.prototype._updateDocumentCategory = function (rowData) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var updateModel, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 3, 5, 6]);
                        this._loading = true;
                        updateModel = {
                            id: rowData.id,
                            name: (_a = rowData.name) !== null && _a !== void 0 ? _a : ''
                        };
                        return [4 /*yield*/, Api.secured.updateDocumentCategory({ body: updateModel, projectId: this.props.project.id })];
                    case 1:
                        _c.sent();
                        return [4 /*yield*/, this._reloadDocumentCategories()];
                    case 2:
                        _c.sent();
                        return [3 /*break*/, 6];
                    case 3:
                        _b = _c.sent();
                        return [4 /*yield*/, this._reloadDocumentCategories()];
                    case 4:
                        _c.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        this._loading = false;
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    DocumentCategoryDialogBody.prototype.updateAllowedOnlyActiveCategories = function () {
        return __awaiter(this, void 0, void 0, function () {
            var oldValue, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        oldValue = this._allowedOnlyActiveCategories;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        this._allowedOnlyActiveCategories = !this._allowedOnlyActiveCategories;
                        return [4 /*yield*/, Api.secured.updateAllowedOnlyActiveCategories({
                                projectId: this.props.project.id,
                                value: this._allowedOnlyActiveCategories
                            })];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        this._allowedOnlyActiveCategories = oldValue;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DocumentCategoryDialogBody.prototype.render = function () {
        var _this = this;
        var isProjectTerminatedOrCompleted = this.props.isProjectTerminatedOrCompleted;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.headerWrapper },
                React.createElement("div", { className: styles.checkboxWrapper },
                    React.createElement("div", { className: styles.checkbox },
                        React.createElement("input", { disabled: isProjectTerminatedOrCompleted, type: "checkbox", checked: this._allowedOnlyActiveCategories, onChange: function () { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.updateAllowedOnlyActiveCategories()];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); } })),
                    React.createElement("div", { className: styles.checkboxText }, "Only active Categories are allowed for Project Documents")),
                React.createElement("div", null,
                    React.createElement(Button, { color: "primary", onClick: function () { return _this._toggleCreateDocumentCategoryModal(); }, disabled: this._isCreateDocumentCategoryOpen || isProjectTerminatedOrCompleted }, "Create Category"))),
            React.createElement(DocumentCategoryDialogGrid, { documentCategories: this._documentCategories, isDataLoading: this._loading, onDelete: this._deleteDocumentCategory, onUpdate: this._updateDocumentCategory, onIsActiveInProjectChange: this._setIsActiveInProject, onReload: this._reloadDocumentCategories, isProjectTerminatedOrCompleted: isProjectTerminatedOrCompleted }),
            this._isCreateDocumentCategoryOpen && (React.createElement(CreateDocumentCategoryDialog, { isOpen: this._isCreateDocumentCategoryOpen, project: this.props.project, onToggle: function () { return _this._toggleCreateDocumentCategoryModal(); }, onSave: this._reloadDocumentCategories }))));
    };
    __decorate([
        observable
    ], DocumentCategoryDialogBody.prototype, "_isCreateDocumentCategoryOpen", void 0);
    __decorate([
        observable
    ], DocumentCategoryDialogBody.prototype, "_loading", void 0);
    __decorate([
        observable
    ], DocumentCategoryDialogBody.prototype, "_documentCategories", void 0);
    __decorate([
        observable
    ], DocumentCategoryDialogBody.prototype, "_allowedOnlyActiveCategories", void 0);
    __decorate([
        action.bound
    ], DocumentCategoryDialogBody.prototype, "_loadDocumentCategories", null);
    __decorate([
        action.bound
    ], DocumentCategoryDialogBody.prototype, "_reloadDocumentCategories", null);
    __decorate([
        action.bound
    ], DocumentCategoryDialogBody.prototype, "_toggleCreateDocumentCategoryModal", null);
    __decorate([
        action.bound
    ], DocumentCategoryDialogBody.prototype, "_deleteDocumentCategory", null);
    __decorate([
        action.bound
    ], DocumentCategoryDialogBody.prototype, "_setIsActiveInProject", null);
    __decorate([
        action.bound
    ], DocumentCategoryDialogBody.prototype, "_updateDocumentCategory", null);
    __decorate([
        action.bound
    ], DocumentCategoryDialogBody.prototype, "updateAllowedOnlyActiveCategories", null);
    DocumentCategoryDialogBody = __decorate([
        observer
    ], DocumentCategoryDialogBody);
    return DocumentCategoryDialogBody;
}(React.PureComponent));
